import React, { useContext, useEffect, useState, useRef } from "react";
import "./TokenCheckoutPage.scss";
import CoinIcon from "../../Assets/Images/coin-icon1.png";
import { TokenContext } from "../../Context/TokenContext";
import { toast } from "react-toastify";
import AuthContext from "../../Context/AuthContext";
import { buyTokensStripe, createCustomer, fetchTokens, updateTokens } from "../../api";
import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import { CardNumberElement, CardExpiryElement, CardCvcElement } from "@stripe/react-stripe-js";
import { useLocation, useNavigate } from "react-router-dom";
import { transactionHistory, fetchSavedCards } from "../../api";
import { CircularProgress } from "@mui/material";
import Disclaimer from "./Disclaimer";

export default function TokenCheckoutpage({ heading, data, clientId, tokensFromNewCard }) {
  const tokenCtx = useContext(TokenContext);
  const authCtx = useContext(AuthContext);
  const navigate = useNavigate();

  const stripe = useStripe();
  const elements = useElements();
  const [emailID, setEmailID] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [focusField, setFocusField] = useState(null);
  const [errors, setErrors] = useState({
    cardinfo: "",
    cardcvc: "",
    cardexpiry: ""
  });
  const [hasSavedCard, setHasSavedCard] = useState(false);

  const location = useLocation();
  const { tokenValue, customerId, orgId, userId, selectedToken } = location.state || {};

  const [cardInfo, setCardInfo] = useState({
    cardNumber: "",
    expMonth: "",
    expYear: "",
    cvv: "***",
  });


  const [useSavedCard, setUseSavedCard] = useState({ cardNumber: true, expiry: true, cvv: true });

  const cardNumberRef = useRef(null);
  const expiryRef = useRef(null);
  const cvvRef = useRef(null);

  const [totalTokens, setTotalTokens] = useState(parseInt(tokenValue?.join(""), 10))
  const [isCardLoading, setIsCardLoading] = useState(false)
  console.log("Received State:", { tokenValue, customerId, orgId, userId, selectedToken, totalTokens });

  let pricePerToken = 50;
  if (totalTokens >= 21 && totalTokens <= 100) {
    pricePerToken = 45;
  } else if (totalTokens > 100) {
    pricePerToken = 40;
  }

  useEffect(() => {
    if (focusField) {
      const inputField = document.getElementById(focusField);
      if (inputField) {
        inputField.focus();
      }
    }
  }, [focusField]);


  useEffect(() => {
    setTotalTokens(parseInt(tokenValue?.join(""), 10))
  }, [tokenValue])
  


  const getDiscountedAmount = () => {
    const tokenCount = isNaN(totalTokens) ? tokensFromNewCard : totalTokens;

    if (tokenCount > 50) {
      return tokenCount * 40;
    } else if (tokenCount > 20) {
      return tokenCount * 45;
    } else {
      return tokenCount * 50;
    }
  };


    const currencyMinorUnits = {
    USD: 2,
    EUR: 2,
    GBP: 2,
    AUD: 2,
    CAD: 2,
    JPY: 0,
    KRW: 0,
    VND: 0,
    BHD: 3,
    KWD: 3,
    OMR: 3,
  };

  const getDiscountedAmountPayload = (currency = "USD") => {
    const tokenCount = isNaN(totalTokens) ? tokensFromNewCard : totalTokens;

    let pricePerToken;
    if (tokenCount > 50) {
      pricePerToken = 40;
    } else if (tokenCount > 20) {
      pricePerToken = 45;
    } else {
      pricePerToken = 50;
    }

    const minorUnit = currencyMinorUnits[currency.toUpperCase()] ?? 2;
    const multiplier = Math.pow(10, minorUnit);

    return tokenCount * pricePerToken * multiplier;
  };

  const originalAmount = (isNaN(totalTokens) ? tokensFromNewCard : totalTokens) * 50;
  const discountedAmount = getDiscountedAmount();
  const savings = originalAmount - discountedAmount;

  // const fetchPaymentMethods = async () => {
  //   const apiUrl = `https://api.stripe.com/v1/payment_methods?customer=${authCtx?.customerId}&type=card`;

  //   try {
  //     const response = await fetch(apiUrl, {
  //       method: "GET",
  //       headers: {
  //         Authorization: `Bearer ${process.env.REACT_APP_STRIPE_API_KEY}`,
  //         "Content-Type": "application/json",
  //       },
  //     });

  //     const data = await response.json();

  //     if (!response.ok) {
  //       throw new Error(data.error?.message || "Failed to fetch payment methods");
  //     }
  //     console.log('card data', data);
  //     if (data?.data?.length > 0) {
  //       const card = data.data[0].card;

  //       setCardInfo({
  //         cardNumber: `xxxx xxxx xxxx ${card.last4}`,
  //         expMonth: card.exp_month.toString().padStart(2, "0"),
  //         expYear: card.exp_year.toString().slice(-2),
  //         cvv: "***",
  //       });
  //       setUseSavedCard({ cardNumber: true, expiry: true, cvv: true });
  //       setHasSavedCard(true);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching payment methods:", error);
  //     setHasSavedCard(false);
  //   }
  // };

  const handlePurchaseHistory = async (paymentIntentStatus) => {
    console.log("paymentIntentStatus",paymentIntentStatus)
    let status;

    if (paymentIntentStatus?.status == "succeeded") {
      status = 'Success'
    }
    else if (paymentIntentStatus?.status == "requires_payment_method") {
      status = 'Failed'
    }
    else if (paymentIntentStatus?.status == "canceled") {
      status = 'Failed'
    }
    else if (paymentIntentStatus?.status == "requires_action") {
      status = 'Pending'
    }
    else if (paymentIntentStatus?.status == "processing") {
      status = 'Pending'
    }
    else if (paymentIntentStatus?.status == "requires_capture") {
      status = 'Pending'
    }

    const exportData = {
      organisationId: orgId,
      stripeCustomerId: authCtx?.customerId,
      stripePaymentMethodId: authCtx?.paymentMethodId,
      amount: getDiscountedAmount(),
      currency: "USD",
      validUntil: new Date().toISOString(),
      token: totalTokens,
      status: status
    };

    const exportResponse = await transactionHistory(exportData);
  }

  const token = localStorage.getItem('token')

  useEffect(() => {
    // fetchPaymentMethods();
    const getSavedCards = async () => {
      setIsCardLoading(true);
      try {
        const savedCards = await fetchSavedCards(customerId, token);

        console.log("savedCards", savedCards);

        if (savedCards && savedCards.length > 0) {
          // const card = savedCards[0].card;
          const card = savedCards?.find((el) => el?.isDefault)?.card;

          setCardInfo({
            cardNumber: `xxxx xxxx xxxx ${card.last4}`,
            expMonth: card.exp_month.toString().padStart(2, "0"),
            expYear: card.exp_year.toString().slice(-2),
            cvv: "***",
          });

          setUseSavedCard({ cardNumber: true, expiry: true, cvv: true });
          setHasSavedCard(true);
        } else {
          setHasSavedCard(false);
       }
      } catch (error) {
        console.error("Error fetching saved cards:", error);
        setHasSavedCard(false);
      } finally {
        setIsCardLoading(false);
      }
    };

    getSavedCards();
    setEmailID(localStorage.getItem('email') || "");
    tokenCtx.setTokenCount(totalTokens)
  }, []);

  const handlePurchaseClick = async () => {
    setIsLoading(true);
    const orgId = authCtx.orgId;
    const email = localStorage.getItem('email')
    const userName = localStorage.getItem('userName')
    const updatedTokens = parseFloat(tokenCtx.selectedToken) + parseFloat(totalTokens);
    let customerId = authCtx?.customerId || localStorage.getItem('customerId')
    let token_stripe_data;
    
    try {
      const tokenPayload = {
        "customerId": customerId,
        "amount": getDiscountedAmountPayload(),
        "currency": "USD",
        "orgId": authCtx?.orgId,
        "userId": authCtx?.userId,
        "token": totalTokens
      };

      if (!customerId) {
        const data = await createCustomer(email, userName, orgId);
        if (data.status === "success") {
          authCtx.addCustomerId(data?.customerId);
          customerId = data?.customerId
        }
      }
      else {
        token_stripe_data = await buyTokensStripe(tokenPayload);

        console.log("token_stripe_data", { token_stripe_data, tokenPayload, authCtx });
        if (token_stripe_data) {
          const card = elements.getElement(CardNumberElement);
          const cardExpiryElement = elements.getElement(CardExpiryElement);
          const cardCvcElement = elements.getElement(CardCvcElement);

          let hasErrors = false

          if (!cardInfo?.cardNumber?.length) {
            if (!card?._complete) {
              setErrors((prevErrors) => ({
                ...prevErrors,
                cardinfo: "Please enter a valid card number.",
              }));
              hasErrors = true;
            }
            if (!cardExpiryElement?._complete) {
              setErrors((prevErrors) => ({
                ...prevErrors,
                cardexpiry: "Please enter a valid expiry date.",
              }));
              hasErrors = true;
            }

            if (!cardCvcElement?._complete) {
              setErrors((prevErrors) => ({
                ...prevErrors,
                cardcvc: "Please enter a valid CVC code.",
              }));
              hasErrors = true;
            }
          }

          if (hasErrors) {
            return;
          }

          const { error, paymentIntent } = await stripe.confirmCardPayment(
            token_stripe_data?.clientSecret,
            {
              payment_method: useSavedCard?.cardNumber ? authCtx?.paymentMethodId : { card },
            }
          );

          if (paymentIntent) {
            handlePurchaseHistory(paymentIntent)
          }

          if (error) {
            if (error?.code === "card_declined") {
              if (error?.decline_code === "insufficient_funds") {
                toast.error("Your card has insufficient funds. Please add funds or try another payment method.");
              } else {
                toast.error("Your payment was declined. Please verify your card details or try a different payment method.");
              }
            } else if (error?.code === "requires_action") {
              toast.error("Authentication required. Please try again or use a different payment method.");
            } else if (error?.code === "incomplete_number") {
              toast.error("Please enter a valid card number. OR Your card number is incomplete.");

            } else if (error?.code === "incomplete_expiry") {
              toast.error("Please enter a valid expiry date. OR Your card’s expiry date is incomplete. OR Your card’s expiry year is in the past.");

            } else if (error?.code === "incomplete_cvc") {
              toast.error("Please enter a valid CVC code. OR Your card’s security code is incomplete.")
            } else if (error?.code === "payment_intent_authentication_failure") {
              toast.error("Authentication required. Please try again or use a different payment method")

            } else {
              toast.error(error?.message);
            }
            console.error("Payment failed:", error.message);
            handlePurchaseHistory(error?.payment_intent)
            setIsLoading(false);
            return;
          }


          if (paymentIntent.status === "requires_action") {
            toast.info("Authentication required. Please complete the authentication process.", {
              autoClose: 5000,
            });

            const { error: confirmError, paymentIntent: confirmedPaymentIntent } = await stripe.confirmCardPayment(
              token_stripe_data?.clientSecret
            );

            if (confirmError) {
              toast.error("Authentication failed. Please try again or use a different payment method.");
              console.error("Authentication failed:", confirmError.message);
              setIsLoading(false);
              return;
            }

            if (confirmedPaymentIntent.status === "succeeded") {
              console.log("Payment successful after authentication:", confirmedPaymentIntent);
              setIsLoading(false);
            }
          }

          if (paymentIntent.status === "succeeded") {



            let payloadToken;

            if (parseInt(tokenCtx.selectedToken) >= 0) {
              payloadToken = parseInt(totalTokens) + parseInt(tokenCtx.selectedToken);
            }
            else {
              payloadToken = parseInt(totalTokens);
            }

            // console.log('payload',tokenCtx.selectedToken,totalTokens,payloadToken)


            const response = await updateTokens({
              orgId: orgId,
              token: payloadToken,
            });

            if (response?.status == "success") {
              console.log("Tokens added successfully");
              // tokenCtx.setSelectedToken(updatedTokens);

              toast.success(`${totalTokens} tokens added successfully!`, {
                position: "top-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              });

              // Navigate to success page
              navigate(`/token-payment-successful?clientId=${clientId}`, {
                state: {
                  totalTokens,
                  discountedAmount: getDiscountedAmount(),
                },
              });
            }
            else {
              console.error("Tokens not added: Invalid response", response);
              toast.error("Failed to add tokens. Please try again.");
            }
          } else {
            console.error("Payment failed:", paymentIntent.status);
            toast.error("Payment failed. Please try again.");
          }
        }
      }
      
    } catch (error) {
      console.error("Error updating tokens:", error);
      toast.error("Error updating tokens. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleEmail = (e) => {
    setEmailID(e.target.value);
  };

  const handleManualInput = (field, ref) => {
    setUseSavedCard((prev) => ({ ...prev, [field]: false }));
    setCardInfo((prev) => {
      if (field === "cardNumber") return { ...prev, cardNumber: "" };
      if (field === "expiry") return { ...prev, expMonth: "", expYear: "" };
      if (field === "cvv") return { ...prev, cvv: "" };
      return prev;
    });

    setTimeout(() => {
      ref?.current?.focus();
    }, 0);
  };

  const cardStyle = {
    style: {
      base: {
        fontSize: "25px",
        fontWeight: 600,
        lineHeight: "30px",
        color: "#394554",
        "::placeholder": {
          color: "#aab7c4",
        },
      },
      invalid: {
        color: "#fa755a",
      },
    },
  };

  const cardNumberStyle = {
    style: {
      base: {
        fontFamily: "Lato",
        fontSize: "18px",
        fontWeight: 500,
        lineHeight: "21.6px",
        color: "#394554",
        letterSpacing: "10px",
        "::placeholder": {
          color: "#aab7c4",
        },
      },
      invalid: {
        color: "#fa755a",
      },
    },
  };

  const expireCardStyle = {
    style: {
      base: {
        fontSize: "18px",
        color: "#32325d",
        fontFamily: "Lato, sans-serif",
        fontWeight: 500,
        lineHeight: "21.6px",
        letterSpacing: "8px",
        color: "rgba(199, 199, 199, 1)",
        width: "95px",
        height: "22px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "::placeholder": {
          color: "#aab7c4",
          letterSpacing: "4px",
        },
      },
      invalid: {
        color: "#fa755a",
      },
    },
  };


  const cvvCardStyle = {
    style: {
      base: {
        fontSize: "18px",
        color: "#32325d",
        fontWeight: 600,
        letterSpacing: "4px",
        backgroundColor: "rgba(255, 255, 255, 1)",
        width: "60px",
        height: "22px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "monospace",
        "::placeholder": {
          color: "#aab7c4",
          letterSpacing: "3px",
        },
      },
      invalid: {
        color: "#fa755a",
      },
    },
  };

  const handleCardChange = (event, field) => {
    setErrors((prev) => ({
      ...prev,
      [field]: event?.error ? event.error.message : "",
    }));
  };

  console.log('useSavedCard.cardNumber', useSavedCard.cardNumber)


  return (
    <div className="tokencheckout-table-container">
      <p className="pagedir">{heading}</p>
      <div className="tokencheckout-table">
        <div className="tokencheckout-body">
          <div className="payment-deatil-container">
            {isCardLoading ?<div style={{ width: '100%', alignItems: 'center', justifyContent: 'center' }}>
              <CircularProgress />
              </div>
            : <>
            <h2 className="heading">Payment Details</h2>
            <div className="payment-info">
              {/* <CardElement /> */}
              {/* <PaymentForm /> */}
              <div className="payment-info-input-area">
                <div className="emailcontainer payment-input-container">
                  <label className="subheader">Email Address<span>*</span></label>
                  <input type="text" className="emailinput" value={emailID} placeholder="Type your email here" onChange={handleEmail} disabled />
                </div>

                <div className="cardnumber payment-input-container">
                  <label className="subheader">Credit Card Number<span>*</span></label>
                  {useSavedCard.cardNumber ? (
                    <input
                      type="text"
                      id="cardNumber"
                      className="inputcardnumber"
                      value={cardInfo.cardNumber}
                      ref={cardNumberRef}
                      disabled={true}
                    />
                  ) : (
                    <CardNumberElement
                      options={cardNumberStyle}
                      className="inputcardnumber"
                      ref={cardNumberRef}
                      onChange={(e) => handleCardChange(e, "cardinfo")}
                      onFocus={() => setUseSavedCard((prev) => ({ ...prev, cardNumber: false }))}
                    />
                  )}
                  {errors.cardinfo && <div className="form-error">{errors.cardinfo}</div>}
                </div>

                <div className="expirecvvcontainer">
                  <div className="expireinput payment-input-container">
                    <label className="subheader">Expiry Date<span>*</span></label>
                    {useSavedCard.expiry ? (
                      <input
                        type="text"
                        id="expMonth"
                        className="inputexpire"
                        value={`${cardInfo.expMonth} / ${cardInfo.expYear}`}
                        ref={expiryRef}
                        disabled={true}
                      />
                    ) : (
                      <CardExpiryElement
                        options={expireCardStyle}
                        className="inputexpire"
                        ref={expiryRef}
                        onChange={(e) => handleCardChange(e, "cardexpiry")}
                        onFocus={() => setUseSavedCard((prev) => ({ ...prev, expiry: false }))}
                      />
                    )}
                    {errors.cardexpiry && <div className="form-error">{errors.cardexpiry}</div>}
                  </div>

                  <div className="cvvinput payment-input-container">
                    <label className="subheader">CVC<span>*</span></label>
                    {useSavedCard.cvv ? (
                      <input
                        id="cvv"
                        type="text"
                        className="inputcvv"
                        value={cardInfo.cvv}
                        ref={cvvRef}
                        disabled={true}
                        />
                      ) : (
                        <CardCvcElement
                        options={cvvCardStyle}
                        className="inputcvv-stripe"
                        ref={cvvRef}
                        onChange={(e) => handleCardChange(e, "cardcvc")}
                        onFocus={() => setUseSavedCard((prev) => ({ ...prev, cvv: false }))}
                        />
                    )}
                    {errors.cardcvc && <div className="form-error">{errors.cardcvc}</div>}
                  </div>
                </div>
              </div>
            </div>
            </>}
            {console.log("totalTokens",totalTokens)}
            <div className="amountinfomation">
              <div className="subtotal">
                <p className="suntext">Subtotal</p>
                <p className="suntext">${totalTokens > 0 ? totalTokens * 50 : 0}</p>
              </div>
              <div className="discount">
                <p className="suntext">Discount</p>
                <p className="suntext">${savings}</p>
              </div>
              <hr className="divider" />
              <div className="total">
                <p className="suntext">Total</p>
                <p className="suntexttotal">${getDiscountedAmount()}</p>
              </div>
            </div>
            <button className="buy-button" onClick={handlePurchaseClick}>
              <p className="button-text">{isLoading ? ( <CircularProgress style={{ color: "#ffffff" }} size={20} /> ) : hasSavedCard ? ( "Make Payment" ) : ( "Add Your Card" )}</p>
            </button>
          </div>
        </div>

        <div className="second-token-container">
          <div className="wallet-text">Wallet</div>
          <div className="first-container">
            <img
              src={CoinIcon}
              alt="Coin Icon"
              width={"22px"}
              height={"22px"}
            />
            <div className="inner-box">You have {tokenCtx.selectedToken} tokens</div>
          </div>
          <div className="second-container">
            <p className="cost-sheet">Pricing</p>
            <div className="inner-cost-sheet">
              <div className="inner-first">
                <p className="text">Self - Assessment</p>
                <div className="token-info">
                  <img src={CoinIcon} alt="Coin Icon" className="img-icon" />
                  <p className="small-text">2 Tokens</p>
                </div>
              </div>
              <div className="inner-first">
                <p className="text">360 Assessment</p>
                <div className="token-info">
                  <img src={CoinIcon} alt="Coin Icon" className="img-icon" />
                  <p className="small-text">4 Tokens</p>
                </div>
              </div>
              <div className="inner-first">
                <p className="text">Group Report</p>
                <div className="token-info">
                  <img src={CoinIcon} alt="Coin Icon" className="img-icon" />
                  <p className="small-text">4 Tokens</p>
                </div>
              </div>
            </div>
          </div>
          <Disclaimer />
        </div>
      </div>
    </div>
  );
}